// react
import React from "react";
import { Link } from "react-router-dom";
// components
import { Icon, List, Grid } from "semantic-ui-react";
import SuperModal from "../modals/SuperModal";
import CookieSettings from "../CookieSettings";

// component
function Footer() {
    // template
    return (
        <Grid className="footer" style={styles.footer}>
            <Grid.Row columns={1}>
                <Grid.Column mobile={16} tablet={10} computer={16}>
                    <div className="logoHead" style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
                        <img src="/images/logos/logo_big.png" alt="logo" />
                        <div className="payment-logos-container">
                            <a
                                href="https://www.mastercard.us/en-us/consumers/payment-technologies/securecode.html"
                                rel="noopener noreferrer"
                                target="_blank"
                                className="payment-logo-link"
                            >
                                <img
                                    src="/images/general/mastercard_logo.png"
                                    height="50"
                                    alt="Mastercard"
                                    className="payment-logo"
                                />
                            </a>
                            <a
                                href="https://moja.tatrabanka.sk/cgi-bin/e-commerce/start/help?type=cardpay_vbv_help&lang=sk"
                                rel="noopener noreferrer"
                                target="_blank"
                                className="payment-logo-link"
                            >
                                <img
                                    src="/images/logos/logo_visa.gif"
                                    height="25"
                                    alt="VISA"
                                    className="payment-logo"
                                />
                            </a>
                        </div>
                    </div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3} className="linking">
                <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={5}
                    className="company linkBlock"
                >
                    <h2>Spoločnosť</h2>
                    <List>
                        <List.Item>
                            <Link to="/about-us">O nás</Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/contact">Kontakt</Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/general-conditions">
                                Všeobecné podmienky používania
                            </Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/privacy">Ochrana osobných údajov</Link>
                        </List.Item>
                        <List.Item>
                            <SuperModal
                                size="small"
                                centered={false}
                                closeIcon
                                trigger={
                                    <span style={{ cursor: "pointer" }}>Nastavenia cookies</span>
                                }
                                content={<CookieSettings />}
                            />
                        </List.Item>
                    </List>
                </Grid.Column>
                <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={5}
                    className="programs linkBlock"
                >
                    <h2>Programy</h2>
                    <List>
                        <List.Item>
                            <Link
                                to="/apsolidarity"
                                style={{ color: "#3577df" }}
                            >
                                #APsolidarity
                            </Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/apimage" style={{ color: "#ffe200" }}>
                                #APimage
                            </Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/apevent" style={{ color: "#50d90d" }}>
                                #APevent
                            </Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/sluzby" style={{ color: "#dc3545" }}>
                                #APwalkIn
                            </Link>
                        </List.Item>
                    </List>
                </Grid.Column>
                <Grid.Column
                    mobile={16}
                    tablet={16}
                    computer={6}
                    className="help linkBlock"
                >
                    <h2>Kontakt</h2>
                    <List>
                        <List.Item>
                            <a href="mailto:info@activitypoint.xyz">
                                info@activitypoint.xyz
                            </a>
                        </List.Item>
                        <List.Item>
                            <a href="mailto:obchod@activitypoint.xyz">
                                obchod@activitypoint.xyz
                            </a>
                        </List.Item>
                    </List>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3} width={16} className="socials " centered>
                <a
                    href="https://www.facebook.com/ActivityPoint.xyz/"
                    target="_blank"
                    className="icon"
                    rel="noopener noreferrer"
                >
                    <Icon name="facebook f" size="big" />
                </a>
                <a
                    href="https://www.instagram.com/activitypoint/"
                    target="_blank"
                    className="icon"
                    rel="noopener noreferrer"
                >
                    <Icon name="instagram" size="big" />
                </a>

                <a
                    href="https://www.tiktok.com/@activitypoint"
                    target="_blank"
                    className="icon"
                    rel="noopener noreferrer"
                >
                    <Icon
                        name="tiktok"
                        style={{
                            color: "#272d45",
                            height: "45px",
                            width: "45px",
                            position: "relative",
                            top: "2.3rem",
                            background: "url(/images/icons/tiktok-white.svg)",
                        }}
                    />
                </a>

                <a
                    href="https://www.youtube.com/channel/UCzfBevKgYpFL5SlH3ajROXQ?view_as=subscriber"
                    target="_blank"
                    className="icon"
                    rel="noopener noreferrer"
                >
                    <Icon name="youtube" size="big" />
                </a>
            </Grid.Row>
            <Grid.Row columns={1} width={16} className="footer-motto" centered>
                <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                    <p style={{
                        margin: '0 0 1rem 0',
                        fontSize: '1rem',
                        fontWeight: '600',
                        letterSpacing: '1px'
                    }}>
                        ZADAJ. VYHĽADAJ. UŽIVAJ.
                    </p>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.75rem',
                        flexWrap: 'wrap',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.75rem',
                            flexWrap: 'wrap'
                        }}>
                            <span style={{ fontSize: '1rem', fontWeight: '600', opacity: 0.9, fontStyle: 'italic' }}>© 2026</span>
                            <a href="https://www.sodobos.com" target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/images/logos/sodonbos-logo.svg"
                                    alt="SODONBOS"
                                    style={{ height: '15px', width: 'auto' }}
                                />
                            </a>
                        </div>
                        <span style={{ fontSize: '0.85rem', opacity: 0.8, marginTop: '0.25rem' }}>All rights reserved</span>
                    </div>
                </div>
            </Grid.Row>
        </Grid>
    );
}

const styles = {
    footer: {
        fontfamily: "Avenir Next LT Pro",
    },
};

export default Footer;
